<template>
    <div class="insurance-business-advantages">
        <ul class="insurance-business-advantages__list">
            <li class="insurance-business-advantages__item" 
                v-for="(card, idx) in advantageCards"
                :key="card.title"
                :class="[...getClasses(idx)]">
                <BusinessAdvantageCard :title="card.title"
                    :description-html="card.descriptionHtml"
                    :icon-name="card.iconName"
                    :comment="card?.comment"
                    :index="idx"
                    />
            </li>
        </ul>
    </div>
</template>

<script>
import BusinessAdvantageCard from '@/components/ui/BusinessAdvantageCard';
export default {
    name: 'BusinessAdvantages',
    components: {
        BusinessAdvantageCard
    },
    data() {
        return {
            advantageCards: [
                {
                    title: 'Комплексный подход',
                    descriptionHtml: 'Уже готовое комплексное решение, предназначенное для страховой защиты вашего бизнеса.',
                    iconName: 'command'
                },
                {
                    title: 'Без осмотра',
                    descriptionHtml: 'Подключите подписку онлайн за 1 минуту. Дальше она будет продляться автоматически.',
                    comment: '*Минимальный срок действия подписки 1 календарный месяц.',
                    iconName: 'eye-slash'
                },
                {
                    title: 'Защита от расходов',
                    descriptionHtml: 'Полис компенсирует расходы в непредвиденных ситуациях, связанных как с деятельностью юридического лица, так и от внешних обстоятельств: действий третьих лиц или повреждений при экстремальных погодных условиях',
                    iconName: 'shield-tick'
                },
                {
                    title: 'Поддержка 24/7',
                    descriptionHtml: 'Звоните <a href="tel:+78007007707">8 800 700 77 07</a> сразу при наступлении страхового случая. Мы расскажем, как оформить документы. Или напишите на электронную почту <a href="mailto:info@zettains.ru">info@zettains.ru</a>',
                    iconName: 'support-24'
                },
            ]
        }
    },
    methods: {
        getClasses(index) {
            const baseClass = 'insurance-business-advantages__item';
            const paddingMap = {
                0: ['right', 'bottom'],
                1: ['left', 'bottom'],
                2: ['right', 'top'],
                3: ['left', 'top']
            };

            const paddingClasses = paddingMap[index].map(side => `${baseClass}--padding-${side}`);
            const borderClasses = [];

            if ([2,3].includes(index)) {
                borderClasses.push(`${baseClass}--border-top`);
            }

            return paddingClasses.concat(borderClasses);
        }
    },
}
</script>

<style scoped lang="scss">
.insurance-business-advantages {
    $border-color: $tetriary;

    &__list {
        position: relative;

        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        @media #{$screen-small} {
            flex-direction: column;
        } 

        &::before {
            position: absolute;
            top: 0;
            left: 50%;
            
            content: "";
            
            width: rem(1px);
            height: 100%;

            transform: translateX(-50%);

            background-color: $border-color;

            @media #{$screen-small} {
                content: none;
            }
        }
    }

    &__item {
        $padding-desktop: 20px;

        @include flex-width-two-in-row(0);

        @media #{$screen-small} {
            width: 100%;
            
            border-top: 1px solid $border-color;

            &:first-child {
                padding-top: 0 !important;
                border-top: none !important;
            }

        } 

        &--padding-left {
            padding-left: $padding-desktop;

            @media #{$screen-small} {
                padding: rem($gap-normal) 0;
            }
        }

        &--padding-top {
            padding-top: $padding-desktop;

            @media #{$screen-small} {
                padding: rem($gap-normal) 0;
            }
        }

        &--padding-right {
            padding-right: $padding-desktop;

            @media #{$screen-small} {
                padding: rem($gap-normal) 0;
            }
        }

        &--padding-bottom {
            padding-bottom: $padding-desktop;

            @media #{$screen-small} {
                padding: rem($gap-normal) 0;
            }
        }

        &--border-top {
            border-top: 1px solid $border-color;
        }
    }
}
</style>